import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MobileStepper from "@mui/material/MobileStepper";
// import Paper from "@mui/material/Paper";
// import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import Person4Icon from "@mui/icons-material/Person4";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import { makeGetRequest } from "../../../utils/utils";
import swal from "sweetalert";
import moment from "moment";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const images = [{}, {}, {}, {}];

function ActivitiesSlider() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const [alertsList, setAlertsList] = React.useState([]);
  const maxSteps = images.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  async function getAllAlerts() {
   await makeGetRequest("society/getallAlerts")
      .then((response) => {
        if (response.status === 201) {
          if (response.data.data) {
            setAlertsList(response.data.data);
          } else {
            setAlertsList([]);
          }
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }
  
  React.useEffect(() => {

    getAllAlerts();

    const interval = setInterval(() => {
      getAllAlerts();
    }, 5000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  function getStepContent(step, index) {
    return (
      <>
        <div className="activityInnerSlide">
          <div className="activityInner1">
            <div className="activityProIco">
              {step.driver_pic ? (
                <Person4Icon src={step.driver_pic} />
              ) : (
                <Person4Icon />
              )}
            </div>
            <h3>
              {step.user_obj.first_name} {step.user_obj.last_name}
            </h3>
            <span>{step.user_obj.contact_no}</span>
            <p>
              Check In By{" "}
              <b>
                {step.resident_fname} {step.resident_lname}
              </b>
            </p>
          </div>
          <div className="activityInner2">
            <h4>Overdue Of Time</h4>
            <span>
              <AccessAlarmIcon /> Snooze
            </span>
          </div>
          <div className="activityInner3">
            {/* <div className="activityInner3In">
                  <p>Check In</p>
                  <span>08:00am</span>
                </div> */}
            <div className="activityInner3In">
              <p>Check In</p>
              <span>
                {" "}
                {moment.utc(step.entry_time).format("DD-MM-YYYY hh:mm A")}
              </span>
            </div>
            <div className="activityInner3In">
              <p>Check Out</p>
              <span>
                {" "}
                {moment.utc(step.exit_time).format("DD-MM-YYYY hh:mm A")}
              </span>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div>
        <Box sx={{ maxWidth: 400, flexGrow: 1 }}>
          <AutoPlaySwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={activeStep}
            onChangeIndex={handleStepChange}
            enableMouseEvents
          >
            {alertsList.map((step, index) => (
              <div key={step.visitor_id ?? index}>
                <form>{getStepContent(step, activeStep)}</form>
                {Math.abs(activeStep - index) <= 2 ? (
                  <Box src={step.driver_pic} alt={step.label} />
                ) : null}
              </div>
            ))}
          </AutoPlaySwipeableViews>
          <MobileStepper
            steps={maxSteps}
            position="static"
            activeStep={activeStep}
            nextButton={
              <Button
                size="small"
                onClick={handleNext}
                disabled={activeStep === maxSteps - 1}
              >
                Next
                {theme.direction === "rtl" ? (
                  <KeyboardArrowLeft />
                ) : (
                  <KeyboardArrowRight />
                )}
              </Button>
            }
            backButton={
              <Button
                size="small"
                onClick={handleBack}
                disabled={activeStep === 0}
              >
                {theme.direction === "rtl" ? (
                  <KeyboardArrowRight />
                ) : (
                  <KeyboardArrowLeft />
                )}
                Back
              </Button>
            }
          />
        </Box>
      </div>
    </>
  );
}

export default ActivitiesSlider;
